export let chatHeader = {
	title: 'Bot',
};
